import { NoApiModeComponent } from './no-api-mode.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared';

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslateModule, SharedModule],
	declarations: [NoApiModeComponent]
})
export class NoApiModePageModule {}
